import {
  VList,
  VSubheader,
  VDivider,
  VRow,
  VCol,
  VCard,
  VCardSubtitle,
  VCardText,
  VChip,
  VSelect,
} from "vuetify/lib";
import VModel from "@/vuetify_custom/v-modal_v1";
import VForm from "@/vuetify_custom/v-form";
import { DATE_DAY_FORMATE } from "@/libs/constants";
import CustomerUtil from "@/views/components/customer/libs/util";
import { formattingNumber } from "@/libs/util";
import Number_Field from "@/vuetify_custom/v-form/components/Number_Field.js";
import { verifyIllegality } from "./utils";
import DynamicForm from "./DynamicForm";
import {
  pre_to,
  initData,
  company_consistency_list,
  sale_status,
} from "./fields";
import { applyOpoenShopApi, getApplyOpenShopDetailApi } from "./services";
import AutocompletesAsync from "@/vuetify_custom/v-form/components/Autocompletes_Async_v1.js";
import moment from "moment";

export default {
  data() {
    return {
      dis: false,
      params: initData(),
      apply_user_list: [],
      principal_list: [],
      manager_name_list: [],
      preparer_list: [],
      account_payee_list: [],
      payee_company_id_hash: {},
      docking_people_list: [],
      contract_list: [],
      current_contract: {},
      submitLoading: false,
    };
  },
  computed: {
    is_tax() {
      const cur_customer = this.$store.state.cur_customer;
      return cur_customer.groups && cur_customer.groups.includes("GROUP_TAX");
    },
    materialsListHash() {
      return this.$store.getters["async/opening_shop_materials_hash"] || [];
    },
    baseInforFields() {
      const _this = this;
      const arr = [
        {
          $_not_dis: !this.params.id,
          label: "单据编号",
          key: "uid",
          cols: 8,
          disabled: true,
        },
        {
          label: "填表人",
          key: "fill_customer_id",
          type: "autocompletes_async_v1",
          "item-value": "id",
          "item-text": "account",
          api: this.$util.api.customer_select_search,
          initList: this.apply_user_list,
          cols: 8,
          required: true,
          rules: [
            (val) => {
              return !!val || "申请人名称必选择";
            },
          ],
          handle_data: ({ customers }) => {
            return customers;
          },
          disabled: true,
        },
        {
          label: "申请人",
          key: "customer_id",
          type: "autocompletes_async_v1",
          "item-value": "id",
          "item-text": "account",
          api: this.$util.api.customer_select_search,
          initList: this.apply_user_list,
          cols: 8,
          required: true,
          rules: [
            (val) => {
              return !!val || "申请人名称必选择";
            },
          ],
          handle_data: ({ customers }) => {
            return customers;
            //  this.apply_user_list = customers
          },
          // disabled: true
        },
        {
          label: "店铺负责人",
          key: "principal_id",
          type: "autocompletes_async_v1",
          "item-value": "id",
          "item-text": "account",
          api: this.$util.api.customer_select_search,
          initList: this.principal_list,
          cols: 8,
          clearable: true,
          handle_data: ({ customers }) => {
            return customers;
            // this.principal_list = customers
          },
          change(data, target) {
            if (!target) {
              _this.params.principal_name = null;
              return;
            }
            _this.params.principal_name = target.account;
            if (!_this.params.payee_user_id) {
              _this.params.payee_user_id = data;
              _this.params.payee_user = target.account;
              _this.docking_people_list = [target];
            }
          },
        },
        {
          label: "店铺实际管理人",
          key: "manager_id",
          type: "autocompletes_async_v1",
          "item-value": "id",
          "item-text": "account",
          api: this.$util.api.customer_select_search,
          initList: this.manager_name_list,
          cols: 8,
          clearable: true,
          handle_data: ({ customers }) => {
            return customers;
            // this.principal_list = customers
          },
          change(data, target) {
            if (!target) {
              _this.params.manager_name = null;
              return;
            }
            _this.params.manager_name = target.account;
          },
        },
        {
          label: "团队",
          key: "team_id",
          type: "team_select",
          cols: 8,
          required: true,
          rules: [
            (val) => {
              return !!val || "团队必选";
            },
          ],
        },
      ];
      return arr.filter((item) => !item.$_not_dis);
    },
    openshopInfor() {
      const arr = [
        {
          label: "开店平台",
          key: "shop_platform",
          cols: 8,
          placeholder: "例如：小红书，抖音等",
          hint: "例如：小红书，抖音等",
          required: true,
          rules: [
            (val) => {
              return !!val || "开店平台必填";
            },
          ],
        },
        {
          label: "店铺类型",
          key: "shop_type",
          placeholder: "例如：专卖店，旗舰店等",
          hint: "例如：专卖店，旗舰店等",
          required: true,
          cols: 8,
          rules: [
            (val) => {
              return !!val || "店铺类型必填";
            },
          ],
        },
        {
          label: "店铺名称",
          key: "shop_name",
          cols: 8,
          required: true,
          rules: [
            (val) => {
              return !!val || "店铺名称必填";
            },
          ],
        },
        {
          label: "财务子账号信息",
          key: "sub_account_info",
          cols: 8,
          type: "textareas_field",
          rows: 3,
          hint: "请补充财务子账号名称及密码信息，若没有则请填写“无”",
          "persistent-hint": true,
        },
        {
          label: "押金",
          type: "number_field",
          key: "deposit",
          d_digits: 2,
          "persistent-hint": true,
          placeholder: "没有则不填",
          cols: 8,
          suffix: "元",
        },
        {
          label: "认证款",
          type: "number_field",
          key: "certification_cost",
          "persistent-hint": true,
          d_digits: 2,
          placeholder: "没有则不填",
          cols: this.params.certification_cost ? 6 : 8,
          suffix: "元",
        },
        {
          $_not_dis:
            [false, null, undefined].includes(this.params.certification_cost) ||
            this.params.certification_cost <= 0,
          label: "预计退回时间",
          type: "date_picker",
          key: "refund_at",
          cols: 6,
        },
      ];
      return arr.filter((item) => !item.$_not_dis);
    },
    collectionInfor() {
      const _this = this;
      const arr = [
        {
          label: "收款平台",
          key: "receipt_platform",
          cols: 8,
          required: true,
          rules: [
            (val) => {
              return !!val || "收款平台必填";
            },
          ],
        },
        {
          label: "平台分成比例（单位：%）",
          type: "number_field",
          key: "sharing_percent",
          cols: 8,
          required: true,
          rules: [
            (val) => {
              return !verifyIllegality(val) || "平台分成比例必填";
            },
          ],
        },
        {
          label: "收款手续费比例（单位：%）",
          type: "number_field",
          key: "fee_percent",
          cols: 8,
          required: true,
          rules: [
            (val) => {
              return !verifyIllegality(val) || "收款手续费比例必填";
            },
          ],
        },
        {
          label: "结算方式",
          key: "payment_means",
          cols: 8,
          required: true,
          rules: [
            (val) => {
              return !!val || "结算方式必填";
            },
          ],
        },
        {
          label: "收款账户",
          key: "payee_company_account_id",
          type: "autocompletes_async_v1",
          "item-value": "id",
          api: this.$util.api.payee_company_account_select_search,
          "item-text": "text_name",
          placeholder: "与开店主体的对应银行一致",
          initList: this.account_payee_list,
          cols: 8,
          required: true,
          rules: [
            (val) => {
              return !!val || "收款账户必选";
            },
          ],
          handle_data: ({ accounts }) => {
            accounts &&
              accounts.forEach((account) => {
                this.payee_company_id_hash[account.id] = account;
              });
            return accounts.map((item) => ({
              ...item,
              text_name: `${item.bank_number}-${item.bank_account}-${item.bank}`,
            }));
          },
          change: (data, target = {}) => {
            if (
              _this.account_payee_list &&
              !_this.account_payee_list.some((item) => item.id === target.id)
            ) {
              _this.account_payee_list.push(target);
            }
            const current = this.payee_company_id_hash[data];
            pre_to.forEach(([pre, cur]) => {
              this.params[cur] = current[pre];
            });
          },
        },
        {
          label: "收款对接人",
          key: "payee_user_id",
          type: "autocompletes_async_v1",
          "item-value": "id",
          "item-text": "account",
          placeholder: "应为开店负责人",
          api: this.$util.api.customer_select_search,
          initList: this.docking_people_list,
          cols: 8,
          required: true,
          rules: [
            (val) => {
              return !!val || "收款对接人必选";
            },
          ],
          handle_data: ({ customers }) => {
            return customers;
          },
          change(data, target = {}) {
            if (
              _this.docking_people_list &&
              !_this.docking_people_list.some((item) => item.id === target.id)
            ) {
              _this.docking_people_list.push(target);
            }
            _this.params.payee_user = target.account;
          },
        },
        {
          label: "开票主体",
          key: "invoice_company_id",
          type: "company_select",
          cols: 8,
          required: true,
          placeholder: "请联系税务吴荔老师确认开票主体",
          rules: [
            (val) => {
              return !!val || "开票主体必选";
            },
          ],
        },
        {
          label: "售卖类型",
          type: "select_field",
          "item-text": "label",
          key: "sale_type",
          cols: _this.params.sale_type === "reality" ? 6 : 8,
          items: [
            {
              label: "实体商品",
              value: "reality",
            },
            {
              label: "课程",
              value: "course",
            },
            {
              label: "会员",
              value: "member",
            },
            {
              label: "其他",
              value: "other",
            },
          ],
          rules: [
            (val) => {
              return !!val || "售卖类型必选";
            },
          ],
        },
        {
          label: "售卖状态",
          type: "select_field",
          "item-text": "label",
          key: "sale_status",
          cols: 8,
          items: sale_status,
          required: true,
          rules: [
            (val) => {
              return !!val || "必选";
            },
          ],
        },
        {
          $_not_dis: this.params.sale_type !== "reality",
          label: "发货方",
          type: "select_field",
          "item-text": "label",
          key: "deliver_type",
          cols: 6,
          items: [
            {
              label: "我司仓库",
              value: "own",
            },
            {
              label: "第三方代发",
              value: "drop_shipping",
            },
          ],
        },
        {
          // $_not_dis:this.params.sale_type !== 'other',
          label: "商品描述",
          key: "sale_type_other",
          type: "textareas_field",
          cols: 8,
          rows: 3,
          rules: [
            (val) => {
              if (this.params.sale_type === "other") {
                return !!val || "[售卖类型-其他]必填";
              }
              return true;
            },
          ],
        },
      ];
      return arr;
    },
    lawWorksInforFields() {
      return [
        {
          label: "申请开店主体",
          key: "company_id",
          type: "company_select",
          cols: 8,
          required: true,
          placeholder: "请联系法务黄佳确认开店主体",
          rules: [
            (val) => {
              return !!val || "申请开店主体必选";
            },
          ],
        },
      ];
    },
    suppleyInforFields() {
      return [
        {
          label: "备注",
          key: "desc",
          type: "textareas_field",
          rows: 4,
        },
      ];
    },
    taxFields() {
      return [
        {
          label: "主体信息",
          type: "select_field",
          "item-text": "label",
          "item-value": "label",
          required: true,
          key: "company_consistency",
          cols: 8,
          multiple: true,
          items: company_consistency_list,
          rules: [(val) => (val && !!val.length) || "必选"],
        },
      ];
    },
  },
  methods: {
    cancel() {
      this.$refs.materials.clear();
      this.dis = false;
      this.params = initData();
      setTimeout(() => {
        ["base", "open_shop", "gathering", "tax", "fw"].forEach((key) => {
          this.$refs[key] && this.$refs[key].resetValidation();
        });
      }, 100);
    },
    show(data) {
      if (data) {
        getApplyOpenShopDetailApi(data).then((res) => {
          const account_payee_obj = {};
          this.params = initData();
          const iniCurrent = initData();
          Object.keys(iniCurrent).forEach((key) => {
            this.params[key] = res[key] || iniCurrent[key];
          });
          this.params.uid = res.uid;

          this.params.refund_at = moment(res.refund_at).format(
            DATE_DAY_FORMATE
          );
          /* 填表人 */
          CustomerUtil.briefInfo(this.params.customer_id).then(
            (fill_customer) => {
              this.preparer_list.push(fill_customer);
              this.apply_user_list.push(fill_customer);
            }
          );
          this.params.fill_customer_id = res.fill_customer_id;
          CustomerUtil.briefInfo(this.params.fill_customer_id).then((res) => {
            this.apply_user_list.push(res);
          });
          /* 店铺负责人列表 */
          this.principal_list =
            (res.principal_id && [
              {
                id: res.principal_id,
                account: res.principal_name || "-",
              },
            ]) ||
            [];
          this.manager_name_list =
            (res.manager_id && [
              {
                id: res.manager_id,
                account: res.manager_name || "-",
              },
            ]) ||
            [];
          /* 收款账户列表 */
          pre_to.forEach((item) => {
            account_payee_obj[item[0]] = res[item[1]];
          });
          account_payee_obj.text_name = `${account_payee_obj.bank_number}-${account_payee_obj.bank_account}-${account_payee_obj.bank}`;
          this.account_payee_list = [account_payee_obj];
          /* 收款对接人 */
          this.docking_people_list = [
            {
              id: this.params.payee_user_id,
              account: this.params.payee_user,
            },
          ];
          /* 法务组信息 */
          this.$refs.materials.init(this.params.materials);
          CustomerUtil.briefInfo(this.params.customer_id).then((res) => {
            this.apply_user_list.push(res);
          });
          if (res.company_consistency) {
            this.params.company_consistency =
              res.company_consistency.split(",");
          }
        });
      } else {
        const cur_customer = this.$store.state.cur_customer;
        this.params = initData();
        this.params.customer_id = cur_customer.id;
        this.apply_user_list = [
          {
            id: cur_customer.id,
            account: cur_customer.account,
          },
        ];
        this.preparer_list = [
          {
            id: cur_customer.id,
            account: cur_customer.account,
          },
        ];
        this.params.fill_customer_id = cur_customer.id;
      }
      this.dis = true;
    },
    editOk() {
      if (this.validate()) {
        const params_clone = JSON.parse(JSON.stringify(this.params));
        // 关联合同
        params_clone.contracts = params_clone.contracts.map((item) => item.id);
        /* ------------------------- 法务材料 -------------------------- */
        const materials = [];
        const materialsClone = this.$refs.materials.getData();
        materialsClone.selected_list.forEach((id) => {
          const labels = this.materialsListHash[id].labels;
          const obj = {
            id,
          };
          if (labels) {
            labels.forEach((label) => {
              if (materialsClone.input_hash[`${id}/${label}`]) {
                if (!obj.tags) {
                  obj.tags = [];
                }
                obj.tags.push({
                  label,
                  value: materialsClone.input_hash[`${id}/${label}`],
                });
              }
            });
          }
          materials.push(obj);
        });
        params_clone.materials = materials;
        /* ------------------- 是否为实体商品 --------------------- */
        if (this.params.real_product === false) {
          delete params_clone.deliver_type;
        }
        if (params_clone.company_consistency) {
          params_clone.company_consistency = Array.isArray(
            params_clone.company_consistency
          )
            ? params_clone.company_consistency.join(",")
            : "";
        }
        this.submitLoading = true;
        applyOpoenShopApi(params_clone)
          .then((res) => {
            this.$Message.success({
              content: params_clone.id ? "编辑成功！" : "新增成功！",
            });
            this.$emit("success", res);
            this.$refs.materials.clear();
            this.cancel();
          })
          .finally(() => {
            this.submitLoading = false;
          });
      }
    },
    validate() {
      return ["base", "open_shop", "gathering", "tax", "fw"]
        .filter((item) => !!this.$refs[item])
        .map((item) => this.$refs[item].validate())
        .every((item) => item);
    },
  },
  render() {
    const _this = this;
    return (
      <VModel
        v-model={_this.dis}
        persistent
        dynamic-height
        title="开店申请"
        max-width="750"
        loading={_this.submitLoading}
        on={{
          ok: _this.editOk,
          cancel: _this.cancel,
        }}
      >
        <div
          style={{
            margin: "0 20px",
          }}
        >
          <VList two-line>
            <VSubheader
              style={{
                padding: "0",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                申请基本信息
              </span>
            </VSubheader>
            <VDivider />
            <div>
              <VForm
                ref="base"
                v-model={_this.params}
                fields={_this.baseInforFields}
              />
            </div>
          </VList>
          <VList two-line>
            <VSubheader
              style={{
                padding: "0",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                开店信息【财务】
              </span>
            </VSubheader>
            <VDivider />
            <div>
              {/* deposit */}
              <VForm
                ref="open_shop"
                v-model={_this.params}
                fields={_this.openshopInfor}
                scopedSlots={{
                  deposit: ({ field }) => {
                    return (
                      <Number_Field
                        field={{
                          ...field,
                          hint:
                            (_this.params.deposit &&
                              formattingNumber(this.params.deposit, 2)) ||
                            "",
                        }}
                        value={_this.params}
                      />
                    );
                  },
                  certification_cost: ({ field }) => {
                    return (
                      <Number_Field
                        field={{
                          ...field,
                          hint:
                            (_this.params.certification_cost &&
                              formattingNumber(
                                this.params.certification_cost,
                                2
                              )) ||
                            "",
                        }}
                        value={_this.params}
                      />
                    );
                  },
                }}
              />
            </div>
          </VList>
          <VList two-line>
            <VSubheader
              style={{
                padding: "0",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                收款信息【财务】
              </span>
            </VSubheader>
            <VDivider />
            <div>
              <VForm
                ref="gathering"
                v-model={_this.params}
                fields={_this.collectionInfor.filter((item) => !item.$_not_dis)}
              />
            </div>
          </VList>
          {!!this.is_tax && (
            <VList two-line>
              <VSubheader
                style={{
                  padding: "0",
                }}
              >
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  税务信息
                </span>
              </VSubheader>
              <VDivider />
              <div>
                <VForm
                  ref="tax"
                  v-model={_this.params}
                  fields={_this.taxFields}
                  scopedSlots={
                    {
                      // company_consistency: ({field}) => {
                      //     return <VSelect
                      //     item-value="value"
                      //     item-text="label"
                      //     items={field.items}
                      //     label={field.label}
                      //     multiple
                      //     v-model={_this.params[field.key]}
                      //     />
                      // }
                    }
                  }
                />
              </div>
            </VList>
          )}
          <VList two-line>
            <VSubheader
              style={{
                padding: "0",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                法务组信息
              </span>
            </VSubheader>
            <VDivider />
            <div>
              <VForm
                ref="fw"
                v-model={_this.params}
                fields={_this.lawWorksInforFields}
              />
              <DynamicForm ref="materials" />
            </div>
          </VList>
          <VList two-line>
            <VSubheader
              style={{
                padding: "0",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                补充信息
              </span>
            </VSubheader>
            <VDivider />
            <div
              style={{
                margin: "10px 0",
              }}
            >
              <VCard flat outlined>
                <VCardSubtitle>关联合同</VCardSubtitle>
                <VCardText>
                  <VRow>
                    {_this.params.contracts &&
                      _this.params.contracts.map((item) => (
                        <VChip
                          key={item.id}
                          close
                          style={{
                            margin: "10px",
                          }}
                          on={{
                            "click:close": () => {
                              _this.params.contracts.forEach((_item, index) => {
                                if (_item.id === item.id) {
                                  this.params.contracts.splice(index, 1);
                                }
                              });
                            },
                          }}
                        >
                          {`${item.uid}-${item.name}`}
                        </VChip>
                      ))}

                    <VCol cols={12}>
                      <VCol cols={6}>
                        <AutocompletesAsync
                          field={{
                            label: "",
                            key: "contract_id",
                            type: "autocompletes_async_v1",
                            "item-value": "id",
                            api: _this.$util.api.contract_select_search,
                            "item-text": "text_name",
                            initList: _this.contract_list,
                            cols: 6,
                            // required: true,
                            handle_data: ({ contracts }) => {
                              return contracts.map((item) => ({
                                ...item,
                                text_name: `${item.uid}-${item.name}`,
                              }));
                            },
                            change: (data, target) => {
                              if (
                                data &&
                                !_this.params.contracts.some(
                                  (item) => item.id === data
                                )
                              ) {
                                _this.params.contracts.push(target);
                              }
                              setTimeout(() => {
                                _this.current_contract.contract_id = null;
                              });
                            },
                          }}
                          value={_this.current_contract}
                        />
                      </VCol>
                    </VCol>
                  </VRow>
                </VCardText>
              </VCard>
              <VForm v-model={_this.params} fields={_this.suppleyInforFields} />
            </div>
          </VList>
        </div>
      </VModel>
    );
  },
};
